module.exports = __webpack_public_path__ + "media/images/escudo2020-d6f51eec67445d2b06443dbde67f0359.png";